import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14 17H5M19 7h-9" }, null, -1),
    _createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "3"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7",
      cy: "7",
      r: "3"
    }, null, -1)
  ]))]))
}
export default { render: render }